module.exports = __webpack_public_path__ + "img/sign.83fb9766.png";